var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kye-preview-video"},[(_vm.isVideo)?_c('video',{attrs:{"src":_vm.url,"controls":""}}):_c('audio',{attrs:{"controls":"","src":_vm.url}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b67c7b3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/public/components/kye-preview/component/file-video.vue
// module id = null
// module chunks = 